export enum InquiryCreateType {
  Consult = 'consult',
  Inquiry = 'inquiry',
}
